import React from "react";
import { useSelector } from "react-redux";
import ErrorAlert from "../UI/ErrorAlert/ErrorAlert";

const NewFormHeader = ({ title, description, error }) => {
  return (
    <div>
      <div className="drawer-wrapper">
        <div className="drawer-title">{title}</div>
        <div className="drawer-description">
          {description} <div className="form-progress"></div>
        </div>
      </div>
      <ErrorAlert errorData={error} style={{ marginBottom: 0 }} />
    </div>
  );
};

export default NewFormHeader;
